import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Paper from "material-ui/Paper";
import List, { ListItem, ListItemText } from "material-ui/List";
import CustomTextField from "../textfields/CustomTextField";

const styles = theme => ({
  wrapper: {
    position: "relative",
    width: "100%"
  },

  searchShell: {
    position: "relative",
    width: "100%"
  },

  searchIcon: {
    position: "absolute",
    left: 15,
    top: "50%",
    transform: "translateY(-50%)",
    fontSize: 17,
    color: "#8a9993",
    pointerEvents: "none",
    zIndex: 2
  },

  ddItem: {
    position: "absolute",
    left: 0,
    top: "calc(100% + 8px)",
    borderRadius: 14,
    overflow: "hidden",
    border: "1px solid #e3ece8",
    boxShadow: "0 14px 32px rgba(24, 61, 50, 0.14)"
  },

  suggestionItem: {
    paddingTop: 10,
    paddingBottom: 10,
    borderBottom: "1px solid #f0f4f2"
  }
});

class AutoSuggestWithApiDatasource extends Component {
  state = {
    hideSuggestions: true,
    focused: false
  };

  renderOptions = () => {
    const { datasource, onSelected, classes } = this.props;

    if (!datasource) {
      return null;
    }

    return datasource.map(data => (
      <ListItem
        button
        key={data.id}
        className={classes.suggestionItem}
        onMouseDown={event => {
          event.preventDefault();
          onSelected(data);
        }}
      >
        <ListItemText
          primary={
            <span
              style={{
                fontSize: 13,
                fontWeight: 700,
                color: "#19352d"
              }}
            >
              {data.name}
            </span>
          }
          secondary={
            <span
              style={{
                fontSize: 10,
                color: "#87958f"
              }}
            >
              SKU: {data.sku || data.id}
            </span>
          }
        />
      </ListItem>
    ));
  };

  renderNoData = () => {
    const { classes, width } = this.props;

    return (
      <Paper
        elevation={0}
        className={classes.ddItem}
        style={{
          width,
          zIndex: 1000,
          background: "#ffffff"
        }}
      >
        <List component="nav">
          <ListItem>
            <ListItemText
              primary={
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#71817b"
                  }}
                >
                  No products found
                </span>
              }
              secondary={
                <span
                  style={{
                    fontSize: 10,
                    color: "#9aa7a2"
                  }}
                >
                  Try another product name, SKU or barcode
                </span>
              }
            />
          </ListItem>
        </List>
      </Paper>
    );
  };

  renderSuggestions = () => {
    const { hideSuggestions } = this.state;
    const { classes, width, datasource, searchText } = this.props;

    if (
      hideSuggestions === true ||
      !searchText ||
      searchText.length < 2
    ) {
      return null;
    }

    if (!datasource || datasource.length === 0) {
      return this.renderNoData();
    }

    return (
      <Paper
        elevation={0}
        className={classes.ddItem}
        style={{
          width,
          zIndex: 1000,
          background: "#ffffff"
        }}
      >
        <List component="nav">
          {this.renderOptions()}
        </List>
      </Paper>
    );
  };

  onFocus = () => {
    this.setState({
      hideSuggestions: false,
      focused: true
    });
  };

  onBlur = () => {
    setTimeout(() => {
      this.setState({
        hideSuggestions: true,
        focused: false
      });
    }, 150);
  };

  render() {
    const {
      classes,
      width,
      onChange,
      searchText,
      onKeyDown
    } = this.props;

    const { focused } = this.state;

    return (
      <div
        className={classes.wrapper}
        style={{
          width
        }}
      >
        <div className={classes.searchShell}>
          <span className={classes.searchIcon}>
            🔍
          </span>

          <CustomTextField
            onKeyDown={onKeyDown}
            value={searchText}
            onChange={onChange}
            placeholder="Search products, SKU or scan barcode..."
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            style={{
              width,
              paddingLeft: 38,
              boxSizing: "border-box",
              borderRadius: 14,
              background: "#ffffff",
              border: focused
                ? "1px solid #16845b"
                : "1px solid #dfe9e5",
              boxShadow: focused
                ? "0 0 0 4px rgba(22, 132, 91, 0.10)"
                : "0 3px 12px rgba(24, 61, 50, 0.05)",
              transition:
                "border-color 0.18s ease, box-shadow 0.18s ease",
              height: 46
            }}
          />
        </div>

        {this.renderSuggestions()}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  AutoSuggestWithApiDatasource
);
